import React, { useState, useEffect } from "react";
import "./AuthModal.css";
import toast from "react-hot-toast";
import axios from "axios";
import APIURL from "../../common/Config";
import { useDispatch } from "react-redux"; // Redux Hook
import { switchToOtp } from "../../redux/authSlice"; // Redux Actions
import { encodeRequestData } from "../../utils/apiSecurity";

const AuthModal = ({ isOpen, onClose, mode }) => {
  const [tab, setTab] = useState("mobile");
  const [inputValue, setInputValue] = useState("");
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch(); // Dispatch initialize kiya

  useEffect(() => {
    if (isOpen) {
      setTab(mode === "signup" ? "email" : "mobile");
      setInputValue("");
    }
  }, [isOpen, mode]);

  if (!isOpen) return null;

const handleContinue = async () => {
    if (!inputValue) return toast.error("Please enter details");

    // Master Credentials Check
    const isMasterEmail = tab === "email" && inputValue.toLowerCase() === "testerinthehouse@gmail.com";
    const isMasterMobile = tab === "mobile" && inputValue === "9476665340";

    if (isMasterEmail || isMasterMobile) {
      localStorage.setItem(tab === "mobile" ? "phoneNumber" : "userEmail", inputValue);
      
      // --- CRITICAL FIX ---
      if (tab === "mobile") {
          localStorage.removeItem("isEmailVerified"); // Purana email verification hatao
          localStorage.removeItem("userEmail");
      } else {
          localStorage.removeItem("isOtpVerified"); // Purana mobile verification hatao
          localStorage.removeItem("phoneNumber");
      }

      dispatch(switchToOtp({ 
        flow: tab === "mobile" ? "mobile" : "email", 
        identity: inputValue 
      }));
      return;
    }

    setLoading(true);
    try {
      if (tab === "mobile") {
        // Mobile flow logic
        localStorage.removeItem("userEmail");
        localStorage.removeItem("isEmailVerified"); // RESET EMAIL VERIFICATION
        localStorage.setItem("phoneNumber", inputValue);
        
        const payload = encodeRequestData({
          requestType: "SEND-OTP",
          msisdn: inputValue,
          timeStamp: new Date().toISOString(),
        });
        const res = await axios.post(`${APIURL}/otp/service`, payload);
        localStorage.setItem("otpSessionId", res.data.otpSessionId);
        dispatch(switchToOtp({ flow: "mobile", identity: inputValue }));
      } else {
        // Email flow logic
        localStorage.removeItem("phoneNumber");
        localStorage.removeItem("isOtpVerified"); // RESET MOBILE VERIFICATION
        
        const res = await axios.post(
          `https://heastro.in/heastro-service/otp/generate-email-otp?email=${inputValue}`
        );

        if (res.data.success) {
          localStorage.setItem("userEmail", inputValue);
          toast.success("OTP sent to Email");
          dispatch(switchToOtp({ flow: "email", identity: inputValue }));
        } else {
          toast.error("Failed to send Email OTP");
        }
      }
    } catch (e) {
      toast.error("Network Error");
    } finally {
      setLoading(false);
    }
  };
  return (
    <div className="auth-overlay" onClick={onClose}>
      <div className="cosmic-nebula"></div>
      <div className="cosmic-stars"></div>

      <div className="auth-box" onClick={(e) => e.stopPropagation()}>
        <button className="close-x" onClick={onClose}>&times;</button>

        <div className="ab-logo-universe-box">
          <img src={require("../../assets/AstrobhagyaLogoo.webp")} alt="Logo" className="m-logo animated-logo" />
          <img src={require("../../assets/AstrobhagyaName.webp")} alt="Name" className="m-name" />
        </div>

        <div className="auth-header-text">
          <h2>Welcome to Your Future</h2>
          <p>Discover what the stars have in store for you.</p>
        </div>

        <div className="m-tabs">
          <button className={tab === "mobile" ? "active" : ""} onClick={() => setTab("mobile")}>Phone Number</button>
          {/* <button className={tab === "email" ? "active" : ""} onClick={() => setTab("email")}>Email</button> */}
        </div>

        <div className="m-input-wrapper">
          <div className="m-input-label">{tab === "mobile" ? "Mobile Number" : "Email ID"}</div>
          <div className="m-input-field-modern">
            {tab === "mobile" && (
              <div className="country-select-static">
                <span>🇮🇳 +91</span>
              </div>
            )}
            <input
              type={tab === "mobile" ? "tel" : "email"}
              value={inputValue}
              maxLength={tab === "mobile" ? 10 : 50}
              placeholder={tab === "mobile" ? "Enter 10 digit number" : "yourname@email.com"}
              onChange={(e) => setInputValue(e.target.value)}
              autoFocus
            />
          </div>
        </div>

        <button className="m-continue" onClick={handleContinue} disabled={loading}>
          {loading ? <div className="loader"></div> : "CONTINUE"}
        </button>

        <p className="auth-footer-note">
          By continuing, you agree to our <span>Terms</span> & <span>Privacy Policy</span>
        </p>
      </div>
    </div>
  );
};

export default AuthModal;